<template>
  <!-- App Header -->
  <Header />

  <!-- * App Header -->

  <!-- App Capsule -->
  <div id="appCapsule">

    <!-- Modal Form -->
    <div class="modal fade modalbox" id="ModalForm" data-bs-backdrop="static" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">جستجوی استانی</h5>
            <a href="#" id="closeProvince" data-bs-dismiss="modal">بستن</a>
          </div>
          <div class="modal-body">
            <div class="login-form">
              <div class="section mt-4 mb-5">
                <img src="../../assets/img/map.svg" width="180" class="img-fluid" alt="" />
                <form>
                  <div class="form-group basic">
                    <div class="input-wrapper">
                      <label class="form-label fw-bold" for="from">مبدا</label>
                      <select class="form-control form-select" id="from" v-model="postData.selectedLoadingCitiesIds">
                        <option selected value="">همه</option>
                        <option v-for="result in results" :key="result.id" :value="result.id">
                          {{ result.name }}
                        </option>
                      </select>
                      <i class="clear-input">
                        <ion-icon name="close-circle"></ion-icon>
                      </i>
                    </div>
                  </div>

                  <div class="form-group basic">
                    <div class="input-wrapper">
                      <label class="form-label fw-bold" for="to">مقصد</label>
                      <select class="form-control form-select" id="to" v-model="postData.selectedDischargeCitiesIds">
                        <option selected value="">همه</option>
                        <option v-for="result in results" :key="result.id" :value="result.id">
                          {{ result.name }}
                        </option>
                      </select>
                      <i class="clear-input">
                        <ion-icon name="close-circle"></ion-icon>
                      </i>
                    </div>
                  </div>
                  <div class="form-group basic">
                    <div class="input-wrapper">
                      <label class="form-label fw-bold" for="to">نوع ناوگان</label>
                      <span class="form-control form-select mt-1" data-bs-toggle="offcanvas"
                        data-bs-target="#actionSheetForm" style="text-align: right;" href="#">{{ selectedState }}</span>
                      <i class="clear-input">
                        <ion-icon name="close-circle"></ion-icon>
                      </i>
                    </div>
                  </div>
                  <div class="mt-2">
                    <button type="button" @click.prevent="searchProvince"
                      class="btn background-ORANGE text-light btn-block btn-lg" data-bs-dismiss="modal">
                      جستجو
                    </button>
                  </div>
                </form>
                <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
                  <div class="offcanvas-header background-TEAL">
                    <h5 class="offcanvas-title text-light">انتخاب ناوگان</h5>
                  </div>
                  <div class="offcanvas-body">
                    <form @submit.prevent="changeFleet">
                      <div class="form-group basic">
                        <div class="input-wrapper">
                          <div class="section full mt-2">
                            <div class="section-title" style="justify-content: center !important;">لطفا ناوگان مورد نظر
                              خود را انتخاب کنید</div>

                            <div class="accordion" id="accordionExample1">
                              <div class="accordion-item">
                                <h2 class="accordion-header">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#accordion5">
                                    نیسان و وانت
                                  </button>
                                </h2>
                                <div id="accordion5" class="accordion-collapse collapse"
                                  data-bs-parent="#accordionExample1">
                                  <div class="accordion-body">
                                    <div class="input-list">
                                      <div class="form-check" v-for="fleet in fleets.coms5" :key="fleet.id">
                                        <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                          :id="'radioList' + fleet.id" v-model="postData.fleet_id"
                                          @click="changeTitleFleet(fleet.title)">
                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                          }}</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item">
                                <h2 class="accordion-header">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#accordion1">
                                    کامیونت
                                  </button>
                                </h2>
                                <div id="accordion1" class="accordion-collapse collapse"
                                  data-bs-parent="#accordionExample1">
                                  <div class="accordion-body">
                                    <div class="input-list">

                                      <div class="form-check" v-for="fleet in fleets.coms1" :key="fleet.id">
                                        <input class="form-check-input" :value="fleet.id" type="radio" name="radioList"
                                          @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                          v-model="postData.fleet_id">
                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                          }}</label>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="accordion-item">
                                <h2 class="accordion-header">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#accordion2">
                                    کامیون 6 چرخ (تک)
                                  </button>
                                </h2>
                                <div id="accordion2" class="accordion-collapse collapse"
                                  data-bs-parent="#accordionExample1">
                                  <div class="accordion-body">
                                    <div class="input-list">
                                      <div class="form-check" v-for="fleet in fleets.coms2" :key="fleet.id">
                                        <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                          @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                          v-model="postData.fleet_id">
                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                          }}</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="accordion-item">
                                <h2 class="accordion-header">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#accordion3">
                                    کامیون 10 چرخ (جفت)
                                  </button>
                                </h2>
                                <div id="accordion3" class="accordion-collapse collapse"
                                  data-bs-parent="#accordionExample1">
                                  <div class="accordion-body">
                                    <div class="input-list">
                                      <div class="form-check" v-for="fleet in fleets.coms3" :key="fleet.id">
                                        <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                          @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                          v-model="postData.fleet_id">
                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                          }}</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="accordion-item">
                                <h2 class="accordion-header">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#accordion4">
                                    تریلی
                                  </button>
                                </h2>
                                <div id="accordion4" class="accordion-collapse collapse"
                                  data-bs-parent="#accordionExample1">
                                  <div class="accordion-body">
                                    <div class="input-list">
                                      <div class="form-check" v-for="fleet in fleets.coms4" :key="fleet.id">
                                        <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                          :id="'radioList' + fleet.id" v-model="postData.fleet_id"
                                          @click="changeTitleFleet(fleet.title)">
                                        <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                          }}</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div class="form-group basic">
                        <button type="button" data-bs-dismiss="offcanvas"
                          class="btn background-ORANGE text-light btn-block">
                          ثبت
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- * Modal Form -->

    <!-- App Header -->
    <div class="appHeader transparent" style="background: #fff !important; top: auto">
      <div class="right">
        <a href="#" class="headerButton" @click="getLocation()">
          <ion-icon class="text-MINT m-1" name="location-outline"></ion-icon>
          بار های نزدیک من
        </a>
      </div>
      <div class="left">
        <a href="#" class="headerButton" data-bs-toggle="modal" data-bs-target="#ModalForm" @click="province">
          <ion-icon class="text-MINT m-1" name="search-outline"></ion-icon>
          جستجوی استانی
        </a>
      </div>
    </div>
    <!-- * App Header -->

    <Placeholder v-if="loading" />

    <div v-else style="background-color: white">
      <div class="section" :class="{ 'mt-3 mb-3': index !== 0, 'mt-0 mb-3 pt-45': index == 0 }"
        v-for="(cargo, index) in cargos" :key="index.id">
        <CardView :cargo="cargo" />
      </div>
      <p class="alert alert-warning text-center" v-if="mode == 0">
        لطفا منتظر بمانید...
      </p>
      <button @click="nextLoadCargo()" class="btn btn-primary btn-block btn-lg" v-if="mode == 1 && loadingNext == 0">
        نمایش بار های بیشتر کلیک کنید...
      </button>
      <button class="btn btn-success btn-lg btn-block" type="button" disabled="" v-if="loadingNext == 1">
        <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
        درحال بارگذاری ...
      </button>
    </div>

    <a href="#" class="button goTop show">
      <ion-icon name="arrow-up-outline"></ion-icon>
    </a>
  </div>
  <!-- * App Capsule -->

  <!-- App Bottom Menu -->
  <Footer v-show="isLoggedIn" />

  <!-- * App Bottom Menu -->

  <!-- App Sidebar -->

  <!-- * App Sidebar -->
</template>
<script>
// import InfiniteScroll from "@/components/cargos/InfiniteScroll";
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import router from "@/router";

import axios from "axios";
import Swal from "sweetalert2";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Master",
  components: {
    CardView,
    Placeholder,
    Header,
    Footer
  },
  data() {
    return {
      mode: 0,
      selectedState: 'انتخاب کنید',
      results: [],
      cargos: [],
      idUser: window.localStorage.getItem("idUser"),
      show: false,
      cityTo: [],
      loading: false,
      postData: {
        selectedLoadingCitiesIds: "",
        selectedDischargeCitiesIds: "",
        fleet_id: "",
      },
      fleets: {
        coms1: [],
        coms2: [],
        coms3: [],
        coms4: [],
        coms5: [],
      },
      loadingNext: 0,
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
    };
  },
  methods: {
    changeTitleFleet(value) {
      this.selectedState = value;
    },
    searchProvince() {

      axios
        .post(
          `https://core.iran-tarabar.ir/api/requestCitiesList`,
          this.postData
        )
        .then((res) => {
          this.cityTo = res.data.selectedLoadingCitiesIds.map((a) => a.id);
          this.cityFrom = res.data.selectedDischargeCitiesIds.map((a) => a.id);
          // console.log(res);
          this.cityTo.forEach((element, index) => {
            this.cityTo[index] = "\n  " + element;
          });

          this.cityFrom.forEach((element, index) => {
            this.cityFrom[index] = "\n  " + element;
          });
          var string = JSON.stringify(this.cityTo);
          var string2 = JSON.stringify(this.cityFrom);
          // string.replace(/"/g,'');
          this.loading = true;

          axios.post(`https://core.iran-tarabar.ir/api/driver/searchLoadForDriver`,
            {
              selectedLoadingCitiesIds: string,
              selectedDischargeCitiesIds: string2,
              fleet_id: this.postData.fleet_id,
            }, this.axiosConfig
          )
            .then((response) => {
              this.loading = false;
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              if (response.data.result == 0) {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: response.data.message,
                  showConfirmButton: true,
                  confirmButtonText: "تایید",
                  // timer: 2000,
                });
              } else {
                this.mode = 1;
                this.cargos = response.data.loads;
                this.show = true;
              }

              // loading.value = false;
              // Swal.fire({
              //   position: 'top-end',
              //   icon: 'success',
              //   title: 'با موفقیت ثبت شد',
              //   showConfirmButton: false,
              //   timer: 2000
              // })
              // setTimeout(function () {
              //   location.reload();
              // }, 2200);
            });
        });
    },
    getFleets() {
      axios.get("https://core.iran-tarabar.ir/api/customer/requestAllFleetsLists")
        .then((response) => {
          this.fleets.coms1 = response.data.fleets.filter(obj => obj.parent_id == 42);
          this.fleets.coms2 = response.data.fleets.filter(obj => obj.parent_id == 43);
          this.fleets.coms3 = response.data.fleets.filter(obj => obj.parent_id == 53);
          this.fleets.coms4 = response.data.fleets.filter(obj => obj.parent_id == 54);
          this.fleets.coms5 = response.data.fleets.filter(obj => obj.parent_id == 81);
        })
        .catch(() => {
          // console.log(res);
          // handle error
          Swal.fire({
            position: "center",
            icon: "error",
            title: "لطفا اینترنت خود را بررسی کنید",
            showConfirmButton: true,
            confirmButtonText: "تایید",
            // timer: 2000
          });
          // loading.value = false;
        });
    },
    cities() {
      axios
        .get("https://core.iran-tarabar.ir/api/public/requestProvinceAndCitiesList")
        .then((response) => {
          this.results = response.data.data.provinces;
        })
        .catch(() => {
          // console.log(res);
          // handle error
          Swal.fire({
            position: "center",
            icon: "error",
            title: "لطفا اینترنت خود را بررسی کنید",
            showConfirmButton: true,
            confirmButtonText: "تایید",
            // timer: 2000
          });
          // loading.value = false;
        });
    },
    province() {
      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?province=1";
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    getLocation() {
      this.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      }
    },
    showPosition(position) {
      axios
        .post(
          `https://core.iran-tarabar.ir/api/driver/v2/searchTheNearestCargo`,
          {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            lastLoadId: 0
          }, this.axiosConfig
        )
        .then((response) => {
          this.mode = 1;
          this.loading = false;
          this.show = true;
          this.cargos = response.data.loads;

          localStorage.setItem("latitude", position.coords.latitude);
          localStorage.setItem("longitude", position.coords.longitude);
          // localStorage.setItem("city", response.data.city);

          axios.get(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + position.coords.latitude + `&longitude=` + position.coords.longitude + `&localityLanguage=fa`)
            .then((response) => {
              localStorage.setItem("city", response.data.city);
              axios.put(`https://core.iran-tarabar.ir/api/driver/updateLocation`, {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                city: response.data.city,
              }, this.axiosConfig).then(() => {
                //
              }).catch(() => {
                //
              });
            });
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert("لطفا موقعیت مکانی خود را روشن کنید.");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          alert("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          alert("An unknown error occurred.");
          break;
      }
    },
    getInitialCargos() {
      this.loading = true;
      axios.get(`https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/0`, this.axiosConfig)
        .then((response) => {
          if (this.$route.query.token != undefined) {
            if (response.data.token == null || response.data.token != this.$route.query.token) {
              axios.patch(`https://core.iran-tarabar.ir/api/driver/saveMyFireBaseToken`, {
                token: this.$route.query.token,
                version: 67,
              }, this.axiosConfig);
            }
          }

          localStorage.setItem("tel", response.data.Tel);
          if (response.data.result == 0) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: response.data.message,
              showConfirmButton: true,
              confirmButtonText: "تغییر ناوگان",
              // timer: 2000,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({ name: 'profile' })
              }
            });
          }
          this.loading = false;
          this.cargos = response.data.loads;
          this.getNextCargo();
          // console.log(this.cargos);
        })
        .catch((res) => {
          if (res.response?.status === 401) {
            localStorage.clear();
            router.push({ name: 'login' });
          }
        });
    },
    getNextCargo() {
      const lastId = this.cargos.at(-1)?.id;

      axios.get(
        `https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${lastId}`, this.axiosConfig
      )
        .then((res) => {
          if (window.localStorage.getItem("score") != 1) {
            Swal.fire({
              title: "نسخه جدید برنامه در دسترس است ",
              text: "لطفا بروزرسانی کنید ",
              imageUrl: "assets/img/bazar-rate.jpg",
              imageWidth: 300,
              imageHeight: 150,
              imageAlt: "bazar app",
              confirmButtonText: "بروزرسانی",
              cancelButtonText: "بعدا",
              showCloseButton: true,
              showCancelButton: true
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.setItem("score", 1);
                window.open("https://cafebazaar.ir/app/com.iran_tarabar.driver");
              } else if (
                result.dismiss === Swal.DismissReason.cancel
              ) {
                localStorage.setItem("score", 1);
                // window.open("https://cafebazaar.ir/app/com.iran_tarabar.driver");
              }
            });
          }
          if (res.data.loads == undefined) {
            this.mode = 2;
          }
          this.cargos.push(...res.data.loads);
          this.mode = 1;
        });
      // console.log(this.cargos[this.cargos.length - 1].id);
    },
    nextLoadCargo() {
      this.loadingNext = 1;
      const lastId = this.cargos.at(-1)?.id;

      axios.get(
        `https://core.iran-tarabar.ir/api/driver/getNewLoadForDriver/${lastId}`, this.axiosConfig
      )
        .then((res) => {
          // console.log(...res.data.loads);

          this.cargos.push(...res.data.loads);
          this.loadingNext = 0;
        })
        .catch(function (error) {
          // handle error
          this.loadingNext = 0;
        });
    },
  },
  handleUnauthorized() {
    Swal.fire({
      title: "راننده محترم!",
      text: "شماره‌ای که با آن وارد برنامه شده‌اید، توسط دستگاه دیگری استفاده شده است!",
      icon: "error",
      confirmButtonText: "ورود مجدد!"
    }).then(() => {
      localStorage.clear();
      router.push({ name: 'login' });
    });
  },
  computed: {
    isLoggedIn() {
      return window.localStorage.getItem("idUser");
    },
  },
  beforeMount() {
    this.getInitialCargos();
    this.cities();
    this.getFleets();
  },
};
</script>
<style>
.pt-45 {
  padding-top: 4rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>